<template>
    <div>
        <v-overlay :value="loading.data" opacity="0" z-index="4">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary">
            </v-progress-circular>
        </v-overlay>
        <v-card
            flat
            v-if="!loading.data">
            <v-card-title>
                {{ $t("JOBCARDS_TITLE") }}
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    v-if="selected.jobCards.length == 1"
                    @click="openJobcardDisplayDialog({id: selected.jobCards[0].id})">
                    <v-icon>mdi-eye</v-icon>
                </v-btn>
                <v-btn 
                    icon
                    @click="refreshDataFetch">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-menu
                    v-model="searchMenuDisplay"
                    absolute=""
                    :close-on-content-click="false">
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                    </template>
                    <JobcardSearchDialog
                        @search="searchList"
                        @submit="searchMenuDisplay = false"/>
                </v-menu>
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item
                            link
                            @click="openJobCardDialog({editMode: false})"
                            >
                            <v-list-item-avatar>
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-title>{{ $t('new_job_card') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="selected.jobCards.length == 1"
                            link
                            @click="openJobcardDisplayDialog({id: selected.jobCards[0].id})"
                            >
                            <v-list-item-avatar>
                                <v-icon>mdi-eye</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-title>{{ $t('show') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="authorizations.jobcards.update && selected.jobCards.length == 1"
                            link
                            @click="openJobCardDialog({editMode: true, id: selected.jobCards[0].id})"
                            :disabled="!selected.jobCards[0].meta.editable">
                            <v-list-item-avatar>
                                <v-icon :disabled="!selected.jobCards[0].meta.editable">mdi-pencil</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t("ACTIONS_MENU_EDIT") }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-if="authorizations.jobcards.delete && selected.jobCards.length == 1"
                            link
                            @click="openJobcardDeleteDialog(selected.jobCards[0].id)"
                            :disabled="!selected.jobCards[0].meta.deletable">
                            <v-list-item-avatar>
                                <v-icon :disabled="!selected.jobCards[0].meta.deletable">mdi-delete</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t("ACTIONS_MENU_DELETE") }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-subtitle>
                {{ $t("JOBCARDS_SUBTITLE") }}
            </v-card-subtitle>
            <v-card-text>
                <v-row>
                    <v-col class="mr-3">
                        <v-switch
                            :label="available"
                            v-model="options.dateLeave"
                            @change="handleDateLeaveChange"
                        >
                        avalible
                        </v-switch>
                    </v-col>
                </v-row>
                <div class="text-center">
                    <v-progress-circular
                        indeterminate
                        v-if="!jobcards"
                        color="primary">
                    </v-progress-circular>
                </div>
                <v-data-table
                    dense
                    :items="jobcards"
                    @dblclick:row="handleRowDoubleClick"
                    :headers="jobcardsHeaders"
                    v-model="selected.jobCards"
                    :page.sync="page"
                    single-select
                    show-select
                    :loading="loading.jobCard"
                    :options.sync="options"
                    :server-items-length="options.itemsLength"
                    v-if="jobcards">
                </v-data-table>
            </v-card-text>
        </v-card>
        <JobCardDialog 
            ref="jobCardDialog"/>
        <DecisionDialog
            ref="decisionDialog"
            @submit="submitDecisionDialog"/>
        <AlertDialog
            ref="alertDialog"/>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <JobcardDisplayDialog
            ref="jobcardDisplayDialog"/>
    </div>
</template>

<script>
import JobcardSearchDialog from '../components/JobcardSearchDialog';
import JobCardDialog from '../components/JobCardDialog';
import DecisionDialog from '../components/DecisionDialog';
import AlertDialog from '../components/AlertDialog';
import RetryDialog from '../components/RetryDialog';
import JobcardDisplayDialog from '../components/JobcardDisplayDialog.vue';
import { mapState, mapActions } from 'vuex';
export default {
    name: 'Home',
    components: {
        JobCardDialog,
        DecisionDialog,
        AlertDialog,
        JobcardSearchDialog,
        RetryDialog,
        JobcardDisplayDialog
    },
    data() {
        return {
            dataLoaded: false,
            searchMenuDisplay: false,
            search: {},
            selected: {
                jobCards: []
            },
            jobcardsHeaders: [
                {text: this.$t("JOBCARDS_CODE"), sortable: false, value: "the_code"},
                {text: this.$t("JOBCARDS_PLATE"), sortable: false, value: "plate_number"},
                {text: this.$t("JOBCARDS_TRUCK_TYPE"), sortable: false, value: "truck_type"},
                {text: this.$t('DRIVER_NAME'), sortable: false, value: "driver_name"},
                {text: this.$t("JOBCARDS_DATE_ENTER"), sortable: false, value: "date_enter"},
                {text: this.$t("JOBCARDS_DATE_LEAVE"), sortable: false, value: "leave_date"},
                {text: this.$t("JOBCARDS_STATE"), value: "state"}
            ],
            loading: {
                data: true,
                jobCard: false
            },
            options: {
                dateLeave: false
            },
            page: 1
        }
    },
    computed: {
        ...mapState("jobcard", ["jobcards"]),
        ...mapState("authentication", ["loggedInUser", "workshopId", "authorizations"]),
        available() {
            return this.$t("JOBCARDS_DATE_LEAVE")
        }
    },
    watch: {
        options: {
            async handler () {
                try{
                    // this.options = this.search;
                    this.options.workshop_id = this.workshopId;

                    this.loading.jobCard = true;
                    let result = await this.fetchJobcards(this.options);
                    this.options.itemsLength = result.data.total;
                    this.loading.jobCard = false;
                }catch (error){
                    let message = error.response ? error.response.data.message : error;
                    this.$refs.retryDialog.open({message})
                }
            },
            deep: true
        }
    },
    methods: {
        ...mapActions("jobcard", ["fetchJobcards", "removeJobcard"]),
        openJobCardDialog(params) {
            this.$refs.jobCardDialog.open(params);
        },
        openJobcard(id) {
            this.$router.push({ path: `/jobcard/${id}` })
        },
        openJobcardDisplayDialog(params) {
            this.$refs.jobcardDisplayDialog.open(params)
        },
        openJobcardDeleteDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t("DELETE_CONFIRM_TITLE"),
                content: this.$t("DELETE_CONFIRM_CONTENT"),
                action: "DELETE_JOBCARD",
                id: id
            });
        },
        submitDecisionDialog(payload) {
            if(payload.action == "DELETE_JOBCARD") {
                this.removeJobcard(payload.id)
                    .then(response => {
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                        this.fetchJobcards({workshop_id: this.workshopId, state: "OPEN"});
                    })
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    });
            }
        },
        openJobcardSearchDialog() {
            this.$refs.jobcardSearchDialog.open();
        },
        searchList(payload) {
            this.search = payload;
            this.createdDataFetch();
            this.searchMenuDisplay = false;
        },
        refreshDataFetch() {
            this.search = {};
            this.createdDataFetch();
        },
        async createdDataFetch() {
            try {
                this.loading.data = true; 
                this.options = {...this.search};
                this.options.itemsPerPage = 10;
                this.options.workshop_id = this.workshopId;
                let result =  await this.fetchJobcards(this.options);
                this.options.itemsLength = result.data.total;
                this.loading.data = false;
            } catch (error) {
                let message = null;
                if(error.response) message = error.response.data.message;
                else message = error;
                this.$refs.retryDialog.open({target: "createdDataFetch", message});
            }
        },
        onRetryDialogSubmit(params) {
            if(params.target == "createdDataFetch") {
                if(params.retry == true) this.createdDataFetch();
            }
        },
        handleRowDoubleClick(e, { item }) {
            this.openJobcardDisplayDialog({id: item.id})
        },
        handleDateLeaveChange() {
            this.page = 1
        }
    },
    created() {
        this.createdDataFetch();    
    }

}
</script>
